import { useState, useEffect } from 'react';
import { getPopupInfo } from '$/api/canvasRquest';
import { PopupPosition } from '$/api/server.types';

export enum CardType {
    SORA = 'sora',
    NANO_BANANA = 'nano_banana',
}

const cardTypeWithPositionMap = {
    canvas: {
        [PopupPosition.CANVAS_RIGHT_BOTTOM_SORA]: CardType.SORA,
        [PopupPosition.CANVAS_RIGHT_BOTTOM_BANANA]: CardType.NANO_BANANA,
    },
    workflow: {
        [PopupPosition.WORKFLOW_RIGHT_BOTTOM_SORA]: CardType.SORA,
        [PopupPosition.WORKFLOW_RIGHT_BOTTOM_BANANA]: CardType.NANO_BANANA,
    },
};

const useCardType = (from: 'canvas' | 'workflow') => {
    const [cardType, setCardType] = useState<CardType | null>(null);
    useEffect(() => {
        getPopupInfo().then((res) => {
            if (res.popup.length > 0) {
                for (const popup of res.popup) {
                    const cardType = cardTypeWithPositionMap[from][popup.position as keyof typeof cardTypeWithPositionMap[typeof from]];
                    if (cardType) {
                        setCardType(cardType);
                        break;
                    }
                }
            }
        })
        .catch(() => {
            setCardType(null);
        });
    }, [from]);
    return cardType;
};


export default useCardType;